module.exports = __webpack_public_path__ + "static/floral@2x-3c90147332891a72a78f8ee527a05e0f.png";